import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateFundMNAssetAllocationNew(state, { id, data }) {
      // 变更状态s
      Vue.set(state.fund, id, data);
    },
  },
  actions: {
    updateFundMNAssetAllocationNew({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNAssetAllocationNew', rootState.native.fund.fundCode)
          .then((json) => {
            commit('updateFundMNAssetAllocationNew', {
              id: rootState.native.fund.fundCode,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {
    currentAsset(state, getters, rootState) {
      return state.fund[rootState.native.fund.fundCode];
    },
  },
};
